<div class="flex items-center gap-3">
  @if (userName(); as name) {
    <span class="text-sm text-muted-foreground">{{ name }}</span>
  }
  <button type="button" class="cursor-pointer" (click)="toggle($event)">
    <hlm-avatar class="!size-8">
      <img hlmAvatarImage [src]="avatarUrl()" alt="User avatar" />
      <span hlmAvatarFallback class="bg-[#E5DCCA] text-foreground text-xs font-medium">
        @if (initials(); as ini) {
          {{ ini }}
        } @else {
          <svg class="w-6 h-6 text-foreground/60" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
        }
      </span>
    </hlm-avatar>
  </button>
</div>

@if (open()) {
  <div class="fixed inset-0 z-40" (click)="open.set(false)"></div>

  <div
    class="fixed z-50 w-56 rounded-lg border border-border bg-card shadow-lg"
    [style.left.px]="dropdownPos().x"
    [style.top.px]="dropdownPos().y"
  >
    <div class="px-4 py-3 border-b border-border">
      @if (userName(); as name) {
        <p class="text-sm font-medium truncate">{{ name }}</p>
      }
      @if (userEmail(); as email) {
        <p class="text-xs text-muted-foreground truncate">{{ email }}</p>
      }
      @if (!userName() && !userEmail()) {
        <p class="text-sm text-muted-foreground">Not signed in</p>
      }
    </div>
    @if (permissionService.isAdmin()) {
      <div class="p-1">
        <button
          type="button"
          class="w-full text-left px-3 py-2 rounded text-sm hover:bg-muted transition-colors cursor-pointer"
          (click)="onAdminDashboard()"
        >
          Admin Dashboard
        </button>
      </div>
    }
  </div>
}
